import { RootState } from 'editor/src/store/index';

/**
 * Whether any text in the design already varies with this condition.
 *
 * Gates the authoring UI the same way the mask and hint controls are gated: a
 * host that does not enable the feature sees no control, but a design that
 * already carries the data keeps its control either way — otherwise an imported
 * template would have per-option text in effect with no way to see or undo it.
 */
const hasTextVariantsForCondition = (state: RootState, conditionId: string): boolean =>
  (state.design.designData?.spreads ?? []).some((spread) =>
    spread.pages[0]?.groups.media?.some(
      (element) => element.type === 'text' && element.extra.textVariants?.conditionId === conditionId,
    ),
  );

export default hasTextVariantsForCondition;
